import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import {IbResponse} from "../ib-response";


declare var getHexAscii:any;
@Component({
  selector: 'app-sco',
  templateUrl: './sco.component.html',
  styleUrls: ['./sco.component.css']
})
export class ScoComponent implements OnInit {
  // private shown: string = 'EQUIFAX';
   scAccount : string ;
   scAccounts : any =[];
  Scaccountmini : any =[];
   accountHolderName: string =sessionStorage.getItem('storedUserName');
    accountInfo : any ;
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';
  constructor(private webService: CallBackEndService) {
  
    //    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    //  this.Scaccountmini=sessionStorage.getItem('scoAccounts');
    // // this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));
    //  console.log("sc accounts "+this.scAccounts);
    //  this.scAccount=this.scAccounts[0];
    //   const request: IbRequest = new IbRequest();
    //   let response: IbResponse = null;
    // request.param1 = getHexAscii('', this.scAccount);
    // request.param2 = this.scAccount;
    // this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
    //   if (data !== null && data.status === 'S200') {
    //     this.accountInfo = data.param5;
    //     this.moduleType = data.param5.moduleType;
    //     this.fullName = data.param5.fullName;
    //     this.clrBalanceStr = data.param5.clrBalanceStr;
    //     console.log('module type' + this.accountInfo);
    //    sessionStorage.setItem('miniAccounSelected', this.scAccount);
    // sessionStorage.setItem('miniSelectedBalance', data.param5.clrBalanceStr);
    // sessionStorage.setItem('miniSelectedName', data.param5.fullName);
    // sessionStorage.setItem('minidModuleType', data.param5.moduleType);
    //    sessionStorage.setItem('miniAcctlist', this.Scaccountmini);
        
    //     //this.showLoanAmount ='Hide';
    //   }
    // });
  
   }

  ngOnInit() {
    
     this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
     this.Scaccountmini=sessionStorage.getItem('scoAccounts');
        this.scAccount="";
  //  // this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));
  //   console.log("sc accounts "+this.scAccounts);
  //   this.scAccount=this.scAccounts[0];
  //    const request: IbRequest = new IbRequest();
  //    let response: IbResponse = null;
  //  request.param1 = getHexAscii('', this.scAccount);
  //  request.param2 = this.scAccount;
  //  this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
  //    if (data !== null && data.status === 'S200') {
  //      this.accountInfo = data.param5;
  //      this.moduleType = data.param5.moduleType;
  //      this.fullName = data.param5.fullName;
  //      this.clrBalanceStr = data.param5.clrBalanceStr;
  //      console.log('module type' + this.accountInfo);
  //     sessionStorage.setItem('miniAccounSelected', this.scAccount);
  //  sessionStorage.setItem('miniSelectedBalance', data.param5.clrBalanceStr);
  //  sessionStorage.setItem('miniSelectedName', data.param5.fullName);
  //  sessionStorage.setItem('minidModuleType', data.param5.moduleType);
  //     sessionStorage.setItem('miniAcctlist', this.Scaccountmini);
       
       //this.showLoanAmount ='Hide';
   //  }
 //  });
  }
  
  getMainAccount()
  {

  
  }
  ScAcctInfo()
  {
     //this.scAccount=this.scAccounts[0];
    console.log("call service ");
      const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.scAccount);
    request.param2 = this.scAccount;

    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        this.accountInfo = data.param5;
        this.fullName = data.param5.fullName;
        this.clrBalanceStr = data.param5.clrBalanceStr;
        this.moduleType = data.param5.moduleType;
         sessionStorage.setItem('miniAccounSelected', this.scAccount);
    sessionStorage.setItem('miniSelectedBalance', data.param5.clrBalanceStr);
    sessionStorage.setItem('miniSelectedName', data.param5.fullName);
    sessionStorage.setItem('minidModuleType', data.param5.moduleType);
       sessionStorage.setItem('miniAcctlist', this.scAccounts);
        console.log("changing data"+this.accountInfo);
        //this.showLoanAmount ='Hide';
      }
    });
  }


}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/sco/sco.component.ts